/* eslint-disable css-modules/no-undef-class */
import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import AnchorLink from '@/components/molecules/anchor-link/anchor-link';
import Button from '@/components/molecules/button/button';
import styles from './inspirational-search-flow-footer.module.scss';

export interface InspirationalSearchFlowFooterProps {
  /** The currently active step */
  currentStep?: number;
  /** Indicates whether to disable the next button */
  disableNext?: boolean;
  /** An event that is triggered when clicking the next button */
  onClickNext?: () => void;
  /** An event that is triggered when clicking the previous button */
  onClickPrevious?: () => void;
  /** An event that is triggered when clicking the result link */
  onClickResult?: () => void;
  /** The url of the result page */
  resultPageUrl?: string;
  /** The total amount of steps */
  stepCount?: number;
}

const InspirationalSearchFlowFooter = ({
  currentStep = 1,
  disableNext = false,
  onClickNext,
  onClickPrevious,
  onClickResult,
  resultPageUrl,
  stepCount = 0,
}: InspirationalSearchFlowFooterProps) => {
  const { t } = useI18n();

  return (
    <div className={styles.component}>
      <div className={styles.buttons}>
        {onClickPrevious && (
          <Button
            className={styles.button}
            onClick={onClickPrevious}
            text={t('items.common.words.back')}
            variant="tertiary"
          />
        )}

        {currentStep < stepCount ? (
          <Button
            className={styles.button}
            disabled={disableNext}
            onClick={onClickNext}
            text={t('items.common.words.next')}
          />
        ) : (
          <Button
            className={styles.button}
            disabled={disableNext}
            onClick={onClickResult}
            text={t('items.common.words.showResults')}
            url={resultPageUrl}
          />
        )}
      </div>

      <div
        className={classNames(styles.linkWrapper, {
          [styles.isVisible]: resultPageUrl,
        })}
      >
        <AnchorLink
          className={styles.link}
          icon="ArrowRight"
          onClick={onClickResult}
          text={t('items.common.words.showResultsNow')}
          url={resultPageUrl}
        />
      </div>
    </div>
  );
};

InspirationalSearchFlowFooter.displayName = 'InspirationalSearchFlowFooter';

export default InspirationalSearchFlowFooter;
